/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router';
import { getMe } from '../services/user.service';
import { getFromLS } from '../utils/utils';

const useMe = () => {
  const [loading, setloading] = useState<boolean>(false);
  const [me, setMe] = useState<any>();
  const history = useHistory();
  
  useEffect(() => {
    let isMounted = true;
    setloading(true);
    const token = getFromLS('userToken');
    
    if (token) {
      getMe(token)
        .then((result: any) => {
          if (isMounted) {
            setMe(result?.data);
          }
          return 'ok'
        })
        .then((ok: string) => {
          if (isMounted) {
            setloading(false);
          }
        })
        .catch(() => {
          if (isMounted) {
            history.push('/');
          }
        });
    }

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    me,
    loading,
  };
};

export default useMe;
